import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { damageWaiverConfigSelector, loadDamageWaiverConfig } from '../ducks/damageWaiver.duck';

const useDamageWaiverConfig = () => {
  const dispatch = useDispatch();
  const config = useSelector(damageWaiverConfigSelector);

  useEffect(() => {
    dispatch(loadDamageWaiverConfig());
  }, [dispatch]);

  return config;
};

export default useDamageWaiverConfig;
